module.exports = __webpack_public_path__ + "static/media/4_r_colon_86.51_4.91.430b1b17.png";